"use client"

import CustomButton from "@/components/ui/custom/CustomButton"
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage,} from "@/components/ui/shadcn/form"
import {Input} from "@/components/ui/shadcn/input"
import {useEnvironment} from "@/hooks/useEnvironment";
import {trackEvent} from "@/lib/analyticsUtil";
import {zodResolver} from "@hookform/resolvers/zod"
import {useState} from "react";
import * as React from "react";
import {useForm} from "react-hook-form"
import {z} from "zod"
import {useToast} from "@/hooks/useToast"

const formSchema = z.object({
    firstName: z.string().min(2, {
        message: "First Name  must be at least 2 characters.",
    }),
    lastName: z.string().min(2, {
        message: "First Name  must be at least 2 characters.",
    }),
    email: z.string().email("a valid email is required")
})

interface FormProps {
    className?: string;
    onSubmitCallback?: () => void;
    children?: React.ReactNode;

    // [key: string]: unknown;
}

export function ShadEmailForm({
                                  onSubmitCallback

                              }: FormProps) {


    const [isSubmitting, setIsSubmitting] = useState(false);
    // TODO: do we need isComplete?
    // const [isComplete, setIsComplete] = useState(false);

    const {toast} = useToast()

    const {isDev} = useEnvironment();

    const IS_DEV = isDev;


    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: IS_DEV ? {
            firstName: "bob",
            lastName: "jones",
            email: "bob@bob.com",
        } : {
            firstName: "",
            lastName: "",
            email: "",
        },
    })


    /**
     *  Do something with the form values.
     * ✅ This will be type-safe and validated.
     * @param formState
     */
    async function onSubmit(formState: z.infer<typeof formSchema>) {

        console.log(formState)


        setIsSubmitting(true);
        let isError = false;
        let responseMessage = ''
        try {
            const response = await fetch('/api/mailChimp/subscribe', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formState),
            });
            console.log('Response', response)
            const data = await response.json();
            console.log('ResponseData:', data);

            if (!response.ok) {
                isError = true;
                throw new Error(data.detail || 'Subscription failed');

            } else {
                // TODO: do we want a default success handler?
                // setIsComplete(true);
                trackEvent('email_signup', {last_name: formState.lastName})
            }
        } catch (error) {
            console.error('Error:', error);
            responseMessage = (error as Error).message;
            // TODO: verify: error object structure
            // responseMessage = error?.message;
            // setErrors({email: ['Failed to subscribe. Please try again.']});
        } finally {
            setIsSubmitting(false);
        }


        if (isError) {
            toast({
                title: "Email Subscribe Error",
                description: responseMessage,
                variant: 'destructive'
            })
        } else {
            toast({
                title: "Email Subscribed!",
                description: `Thank you, ${formState.firstName}`,
                variant: 'success'
            })
            onSubmitCallback?.();
        }
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="firstName"
                    render={({field}) => (
                        <FormItem>
                            <FormLabel>First Name</FormLabel>
                            <FormControl>
                                <Input placeholder="First Name" {...field} />
                            </FormControl>

                            {/*<FormDescription>*/}
                            {/*    This is your first name*/}
                            {/*</FormDescription>*/}
                            <FormMessage className={"mt-1 text-xs text-red-500"}/>
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="lastName"
                    render={({field}) => (
                        <FormItem>
                            <FormLabel>Last Name</FormLabel>
                            <FormControl>
                                <Input placeholder="Last Name" {...field} />
                            </FormControl>

                            {/*<FormDescription>*/}
                            {/*    This is your last name*/}
                            {/*</FormDescription>*/}
                            <FormMessage className={"mt-1 text-xs text-red-500"}/>
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="email"
                    render={({field}) => (
                        <FormItem>
                            <FormLabel>Email</FormLabel>
                            <FormControl>
                                <Input type="email" placeholder="Email" {...field} />
                            </FormControl>

                            {/*<FormDescription>*/}
                            {/*    This is your email*/}
                            {/*</FormDescription>*/}
                            <FormMessage className={"mt-1 text-xs text-red-500"}/>
                        </FormItem>
                    )}
                />
                <CustomButton
                    type="submit"
                    disabled={isSubmitting}
                    showArrow={true}
                    className={`text-white border-0 py-2 px-8 focus:outline-none rounded text-lg ${
                        isSubmitting ? 'bg-red-500' : 'bg-red-600 hover:bg-red-500 focus:bg-red-500'
                    }`}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </CustomButton>
            </form>
        </Form>
    )
}
